import { createAction } from '@reduxjs/toolkit'

export const setCookieAgreement = createAction<boolean>('@@cookieAgreement/SET_COOKIE_AGREEMENT')
